"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-2c9dbbe6"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "dispose-info local-main-page" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_OverdueDetail = (0, vue_1.resolveComponent)("OverdueDetail");
    const _component_FlowEdit = (0, vue_1.resolveComponent)("FlowEdit");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.overdueRecordId)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_OverdueDetail, {
                key: 0,
                id: _ctx.overdueRecordId,
                module: ['contract', 'customer', 'vehicle', 'overdue', 'collection', 'letter']
            }, null, 8, ["id"]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_FlowEdit, {
            ref: "flow-edit",
            mainData: _ctx.mainData,
            flow: _ctx.flow.data,
            disabled: _ctx.isFinished,
            payload: { id: _ctx.currentParams.overdueRecordOrFlowId },
            onBack: _ctx.onBack
        }, null, 8, ["mainData", "flow", "disabled", "payload", "onBack"])
    ]));
}
exports.render = render;
